<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 3C1 4.10457 1.89543 5 3 5C4.10457 5 5 4.10457 5 3C5 1.89543 4.10457 1 3 1C1.89543 1 1 1.89543 1 3Z"
      :fill="color"
    />
    <path
      d="M19 13C19 14.1046 18.1046 15 17 15C15.8954 15 15 14.1046 15 13C15 11.8954 15.8954 11 17 11C18.1046 11 19 11.8954 19 13Z"
      :fill="color"
    />
    <path
      d="M19 3.75C19.4142 3.75 19.75 3.41421 19.75 3C19.75 2.58579 19.4142 2.25 19 2.25V3V3.75ZM1 12.25C0.585786 12.25 0.25 12.5858 0.25 13C0.25 13.4142 0.585787 13.75 1 13.75L1 13L1 12.25ZM9 3V3.75L19 3.75V3V2.25L9 2.25V3ZM1 3H0.25C0.25 4.51878 1.48122 5.75 3 5.75V5V4.25C2.30964 4.25 1.75 3.69036 1.75 3H1ZM3 5V5.75C4.51878 5.75 5.75 4.51878 5.75 3H5H4.25C4.25 3.69036 3.69036 4.25 3 4.25V5ZM5 3H5.75C5.75 1.48122 4.51878 0.25 3 0.25V1V1.75C3.69036 1.75 4.25 2.30964 4.25 3H5ZM3 1V0.25C1.48122 0.25 0.25 1.48122 0.25 3H1H1.75C1.75 2.30964 2.30964 1.75 3 1.75V1ZM11 13V12.25L1 12.25L1 13L1 13.75L11 13.75V13ZM19 13H18.25C18.25 13.6904 17.6904 14.25 17 14.25V15V15.75C18.5188 15.75 19.75 14.5188 19.75 13H19ZM17 15V14.25C16.3096 14.25 15.75 13.6904 15.75 13H15H14.25C14.25 14.5188 15.4812 15.75 17 15.75V15ZM15 13H15.75C15.75 12.3096 16.3096 11.75 17 11.75V11V10.25C15.4812 10.25 14.25 11.4812 14.25 13H15ZM17 11V11.75C17.6904 11.75 18.25 12.3096 18.25 13H19H19.75C19.75 11.4812 18.5188 10.25 17 10.25V11Z"
      :fill="color"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  width: {
    type: [String, Number],
    default: "20",
  },
  height: {
    type: [String, Number],
    default: "16",
  },
  color: {
    type: String,
    default: "#003D6A",
  },
});
</script>
